import { render, staticRenderFns } from "./materialManagement.vue?vue&type=template&id=1aa83a47&scoped=true&"
import script from "./materialManagement.vue?vue&type=script&lang=js&"
export * from "./materialManagement.vue?vue&type=script&lang=js&"
import style0 from "./materialManagement.vue?vue&type=style&index=0&id=1aa83a47&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa83a47",
  null
  
)

export default component.exports